import React, { Fragment, useState } from 'react'
import { Card } from 'react-bootstrap'
import subs from '../../Assets/Images/subs.png'
import { FaCheck } from 'react-icons/fa6'
import useSiteInfo from '../../Hooks/SiteInfo/useSiteInfo'
import { cancelSubscription } from '../../Services/Subscription'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import Loader from '../Main/Loader'
import useBooks from '../../Hooks/Books/useBooks'


const MySubscriptionTab = () => {

    const { user } = useSelector((state) => state.user)
    const [isloading, setIsLoading] = useState();

    console.log("user", user)

    const handleCancelSubscription = async () => {
        setIsLoading(true)
        let response = await cancelSubscription(user?.id)
        if (response.statusCode === 200) {
            // setSiteInfo(response?.response?.data)
            toast?.success(response?.message)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value)
            // }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const {
        handleSiteInfo,
        siteInfo,
        months,
        handleSubmit,
        activeyears,
        handleMonths
    } = useSiteInfo();

    const {
        checkSubs
    } = useBooks();


    return (
        <Fragment>
            <h5 className='fw-600 border-bottom pb-3'>My Subscription</h5>

            <div className="col-lg-8">
                <Card className='border-0 rounded-4 overflow-hidden'>
                    <Card.Img variant="top" src={siteInfo?.imageUrl + '/' + siteInfo?.subscribeBanner} />
                    <Card.Body className='bg-light '>
                        <Card.Text>
                            <h5 className='s-18'>
                                Subscription Box will include:
                            </h5>

                            <p className='s-14'><FaCheck size={14} className='me-1' />
                                {checkSubs?.data ? JSON.parse(checkSubs.data).join(", ") : ""}
                            </p>

                            <h5 className='s-18'>
                                Renewal Date:
                            </h5>

                            <p className='s-14'><FaCheck size={14} className='me-1' />
                                {checkSubs?.end_date ? checkSubs?.end_date : ""}
                            </p>
                            <p className='s-17 text-danger fw-600'>Price: ${siteInfo?.subscriptionFees ? siteInfo?.subscriptionFees : ""}/ month</p>

                        </Card.Text>

                        <button onClick={handleCancelSubscription} className='btn btn-danger w-100 '>
                            {isloading ? <Loader /> : "Cancel "}
                        </button>

                    </Card.Body>
                </Card>

            </div>

        </Fragment>
    )
}

export default MySubscriptionTab